<template>
  <div class="article-card">
    <div class="tags">
      <div class="tag">
        <span>{{computeTime()}}</span>
      </div>
    </div>
    <img :src="content.picture_url" />
    <div class="content-text-wrap">
      <p class="title">{{content.title}}</p>
      <div class="item-footer">
        <span class="author">{{content.author ? content.author.nickname : ''}}</span>
        <span class="hot">{{content.pv}}</span>
      </div>
    </div>
    <div class="menu">
      <div class="menu-item" @click="handleToRestore">
        <i class="el-icon-refresh-left"></i>
        <span>还原</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToClone">
        <i class="el-icon-document-copy"></i>
        <span>克隆</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
import { articleRemove, articleRestore, articleClone } from '@/api/article'
import { formatTime } from '@/utils/helper'

export default {
  name: "article-card",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 倒计时计算
    computeTime() {
      if (!this.content.update_time) { return '' }
      const time = this.$moment(this.content.update_time).add(30, 'days').valueOf()  - Date.now()
      return formatTime(time/1000)
    },
    // 还原
    handleToRestore() {
      // 二次确认
      this.$confirm('确定要还原吗？', '提示', {
        type: 'warning'
      }).then(() => {
        articleRestore({id: this.content.id}).then(res => {
          this.$message.success(`还原成功，请在内容管理中查看`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
    // 克隆
    handleToClone() {
      // 二次确认
      this.$confirm('确定要克隆吗？', '提示', {
        type: 'warning'
      }).then(() => {
        articleClone({id: this.content.id}).then(res => {
          this.$message.success(`克隆成功，请在内容管理中查看`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
    // 删除
    handleToRemove() {
      // 二次确认
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        articleRemove({id: this.content.id}).then(res => {
          this.$message.success(`删除成功`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
  },
};
</script>

<style lang="less" scoped>
.article-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
    }
  }

  img {
    width: 100%;
    height: 136px;
    object-fit: cover;
  }
  .content-text-wrap {
    display: flex;
    flex-direction: column;
    height: 82px;
    padding: 10px;
  }
  .title {
    flex: 1;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  a {
    text-decoration: none;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
